var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.overview)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('frm-spinner')],1):_c('frm-overview',{attrs:{"config":_vm.overview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }